import { connect } from 'react-redux'
import { goBack } from 'react-router-redux'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'
import at from 'lodash/at'

import { loadValidWorkOrders, transferArea } from '../../actions/work-orders'
import { fetchTechniciansForWorkOrder } from '../../actions/technicians'
import { loadLocations } from '../../actions/locations'

import TransferAreaModal from '../../components/work-orders/transfer-area-modal'

const mapStateToProps = (state, props) => {
  const servicing = state.servicings[props.params.areaId]
  const pagination = get(state, `pagination.validWorkOrders.${props.params.areaId}`, {})
  const validWorkOrders = at(state.workOrders, pagination.ids || [])
  let sortedWorkOrders = {}
  let workOrderKeys = []

  sortedWorkOrders = groupBy(
    validWorkOrders,
    (workOrder) => workOrder.startsAt.format('YYYY-MM-DD')
  )

  workOrderKeys = Object.keys(sortedWorkOrders)

  return {
    hasNextPage: pagination.nextPageUrl,
    modalTitle: "Transfer Area",
    submitButtonText: "Transfer",
    sortedWorkOrders,
    workOrderKeys,
    getLocation: (locationId) => state.locations[locationId]
  }
}

const mapDispatchToProps = (dispatch, props) => {
  dispatch(loadValidWorkOrders(props.params.areaId))
  dispatch(fetchTechniciansForWorkOrder(props.params.workOrderId))
  dispatch(loadLocations())

  return {
    handleClose () {
      dispatch(goBack())
    },

    onSubmit (data) {
      return dispatch(transferArea(props.params.areaId, data.workOrderId))
        .then(action => action.error && Promise.reject({ _error: action.payload.errors[0] }))
        .then(action => dispatch(goBack()))
    },
    onLoadNextPage () {
      dispatch(loadValidWorkOrders(props.params.areaId, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferAreaModal)



// WEBPACK FOOTER //
// ./src/containers/work-orders/transfer-area-modal-container.js